<template>
  <v-card>
    <v-card-title
      class="headline grey lighten-2"
      primary-title
    >
      Новая заметка
    </v-card-title>

    <v-card-text>
      <v-select
        :items="categories"
        label="Категория"
        item-text="caption"
        item-value="id"
        v-model="currentNote.categoryId"
      ></v-select>
      <v-textarea
        name="input-7-1"
        label="Заметка"
        v-model="currentNote.noteText"
        hint="Что надо запомнить?"
      ></v-textarea>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="cancelEditing"
        color="orange"
        text
      >Отмена</v-btn>
      <v-btn
        @click="saveNote"
        color="primary"
      >Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  SET_EDITED_NOTE_ACTION, SAVE_EDITED_NOTE_ACTION,
} from '../store/actions/notes-actions';

export default {
  name: 'EditNoteDialog',
  props: ['note'],
  data() {
    return {
      categoryId: this.note.categoryId ?? -1,
      text: this.note.noteText ?? '',
    };
  },
  computed: {
    categories() {
      return this.$store.getters.categoriesList;
    },
    currentNote() {
      return this.$store.getters.currentNote ?? {};
    },
  },
  methods: {
    cancelEditing() {
      this.$store.dispatch(SET_EDITED_NOTE_ACTION, undefined);
    },
    saveNote() {
      this.$store.dispatch(SAVE_EDITED_NOTE_ACTION, this.currentNode);
    },
  },
};
</script>

<style scoped>

</style>
